import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { DragDropContext } from "@hello-pangea/dnd";
/**
 * In order to use drag and drop, you need to have the part of your React tree that you want to be able to use drag and drop wrapped in a DragAndDropContext.
 */
export const DragAndDropContext = ({ onDragEnd, onBeforeCapture, onBeforeDragStart, onDragStart, onDragUpdate, ...rest }) => {
    return (_jsx(DragDropContext, { onDragEnd: onDragEnd, onBeforeCapture: onBeforeCapture, onBeforeDragStart: onBeforeDragStart, onDragStart: onDragStart, onDragUpdate: onDragUpdate, ...rest }));
};
//# sourceMappingURL=DragAndDropContext.js.map